export const getUserState = ({ user }) => user;

export const getSignupRequestSendingState = (state) =>
  getUserState(state).sending;

export const getSignupRequestSentState = (state) =>
  getUserState(state).signupRequestSent;

export const getUserErrorState = (state) => getUserState(state).errors;

export const getUserStateData = (state) => getUserState(state).data;
